// extracted by mini-css-extract-plugin
export default {"dialog":"HKoxPVUoZacay3j7"};